import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';
import BaseButtonSubmit from '@/views/base/BaseButtonSubmit.vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import SignUpForm from '@/views/pages/signUp/SignUpForm.vue';
import { useSignUpComposable } from '@/composables/useSignUp';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { readUserLocale } from '@/store/main/getters';
import { store } from '@/store/index';

declare global {
  interface Window {
    verifyRecaptchaCallback: (response: string) => void;
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUpPage',
  setup(__props) {

const locale = computed(() => readUserLocale(store));
const compatibleLocale = locale.value.split('-')[0];

const m = defineMessages({
  freeTrial: '無料トライアルをお試しください',
  tryScanFeature: 'SDSスキャン機能を10件までお試しいただけます',
  fillForm: '以下のフォームを入力してください。',
  useImmediately: '登録後、すぐにお使いいただけます',
  agree: 'に同意に同意する',
  chemikanDescription:
    'ケミカンは、SDSを一元管理する法人向けのツールです。\nSDSの一元管理以外の目的でケミカンを利用されていると弊社が判断したは、お客様の利用を断り、又はお客様としての登録を抹消する場合が有ります。\nお客様に事前に通知することなく、本サービスの利用の全部または一部を制限または停止、もしくはお客様としての登録を抹消することができるものとします。',
  useKemikanFree: 'ケミカンを無料で使う',
});

const checkedTerm = ref(false);
const isRecaptchaVerified = ref(
  process.env.VUE_APP_ENV === 'e2e' ? true : false
);
const siteKey = ref(process.env.VUE_APP_SITE_KEY);

const {
  isValidForm,
  isLoading,
  firstName,
  lastName,
  middleName,
  phone,
  department,
  position,
  companyName,
  email,
  password,
  recaptchaToken,
  submit,
} = useSignUpComposable();

window.verifyRecaptchaCallback = (response: string) => {
  recaptchaToken.value = response;
  isRecaptchaVerified.value = !!response;
};

onMounted(() => {
  const recaptchaScript = document.createElement('script');
  recaptchaScript.src = 'https://www.google.com/recaptcha/enterprise.js';
  recaptchaScript.async = true;
  recaptchaScript.defer = true;
  document.body.appendChild(recaptchaScript);
});

return { __sfc: true,locale, compatibleLocale, m, checkedTerm, isRecaptchaVerified, siteKey, isValidForm, isLoading, firstName, lastName, middleName, phone, department, position, companyName, email, password, recaptchaToken, submit, BaseButtonSubmit, BaseFormCard, SignUpForm, sharedMessages }
}

})